<div class="company-detail-wrapper" [ngClass]="{ active: view === 'portfolio' }" *ngIf="!isLoading; else noData">
  <div class="company-detail-header" *ngIf="showActions">
    <p data-cy="text-company-name">{{ company.name }}</p>
    <app-strategy-company-actions
      [activeTab]="activeTab"
      [blockedCompaniesIDs]="blockedCompaniesIDs"
      [company]="company"
      [listType]="listType"
      [selectedCompanyID]="selectedCompanyID"
      [location]="'companyDetail'"
      [wishedCompaniesIDs]="wishedCompaniesIDs"
      (updateLoadingID)="updateLoadingCompany($event)"
    ></app-strategy-company-actions>
  </div>
  <div class="company-detail-image" *ngIf="company.logo" [ngStyle]="getCompanyCoverImage(company)">
    <img [src]="company.logo" />
  </div>
  <div class="company-detail-content">
    <div class="company-detail-topics" *ngIf="company.topics.length || company.is_balance">
      <div class="company-detail-topic" *ngIf="company.is_balance">
        <ng-container *ngIf="view === 'portfolio'; else stabilityPersonalise">
          <app-ui-tooltip
            (click)="openWhyInyova($event)"
            icon="/assets/images/stability.svg"
            [content]="'<a>' + ('learn_more' | translate) + '</a>'"
            [title]="'new_strategy.portfolio_screen.stock_ratio.stock.popup.title' | translate"
            size="large"
            (mouseenter)="trackTooltip('stability')"
          ></app-ui-tooltip>
        </ng-container>
        <ng-template #stabilityPersonalise>
          <ng-container *ngIf="activeTab === 'inyovaStocks'; else showFinalStability">
            <ng-container *ngFor="let additionalTopic of company.additional_topics">
              <app-ui-tooltip
                [icon]="additionalTopic.icon"
                [content]="additionalTopic.desc"
                [title]="additionalTopic.name"
                size="large"
                (mouseenter)="trackTooltip(additionalTopic.name)"
              ></app-ui-tooltip>
            </ng-container>
          </ng-container>
          <ng-template #showFinalStability>
            <app-ui-tooltip
              icon="/assets/images/stability.svg"
              [content]="'new_strategy.personalise.recommendations.tooltip.stability.p' | translate"
              [title]="'new_strategy.portfolio_screen.stock_ratio.stock.popup.title' | translate"
              size="large"
              (mouseenter)="trackTooltip('stability')"
            ></app-ui-tooltip>
          </ng-template>
        </ng-template>
      </div>
      <div class="company-detail-topic" *ngFor="let item of company.topics">
        <app-ui-tooltip
          [icon]="item.icon"
          [content]="item.desc"
          [title]="item.name"
          size="large"
          (mouseenter)="trackTooltip(item.name)"
        ></app-ui-tooltip>
      </div>
    </div>
    <div class="company-detail-about">
      <p class="category-title">{{ 'companyDescription.section1.title' | translate }}</p>
      <div class="company-detail-infos">
        <div class="company-detail-info">
          <span class="icon-i-location"></span>
          <span>{{ company.based }}</span>
        </div>
        <div class="company-detail-info">
          <span class="icon-i-sector"></span>
          <span>{{ getCompanySector(company) | translate }}</span>
        </div>
        <div class="company-detail-info">
          <span class="icon-i-globe"></span>
          <span>
            <a href="{{ company.link }}" target="_blank">{{ company.link_string }}</a>
          </span>
        </div>
      </div>
      <div *ngIf="company.desc?.length">
        <ng-container *ngIf="company.desc?.length > limitSize[0]; else shortDesc">
          <p [ngClass]="{ 'limit-text': limitDesc }" [innerHtml]="limitDesc ? (company.desc | slice: 0 : limitSize[0]) : company.desc"></p>
          <strong [ngClass]="{ more: limitDesc }" (click)="limitCopy('limitDesc')">{{
            'companyDescription.' + (limitDesc ? 'readMore' : 'showLess') | translate
          }}</strong>
        </ng-container>
        <ng-template #shortDesc>
          <p [innerHtml]="company.desc"></p>
        </ng-template>
      </div>
      <div
        class="extra-copy"
        *ngIf="company.good_bullet_points?.length === 0 && company.bad_bullet_points?.length === 0 && company.extra_desc?.length"
      >
        <ng-container *ngIf="company.extra_desc?.length > limitSize[0]; else shortExtraDesc">
          <p
            [ngClass]="{ 'limit-text': limitExtraDesc }"
            [innerHtml]="limitExtraDesc ? (company.extra_desc | slice: 0 : limitSize[0]) : company.extra_desc"
          ></p>
          <strong [ngClass]="{ more: limitExtraDesc }" (click)="limitCopy('limitExtraDesc')">
            {{ 'companyDescription.' + (limitExtraDesc ? 'readMore' : 'showLess') | translate }}
          </strong>
        </ng-container>
        <ng-template #shortExtraDesc>
          <p [innerHtml]="company.extra_desc"></p>
        </ng-template>
      </div>
    </div>
    <div class="company-detail-additional-topics" *ngIf="company.additional_topics?.length && activeTab !== 'inyovaStocks'">
      <p>
        {{
          (company.is_balance ? 'companyDescription.section1.additionalTopicsStability' : 'companyDescription.section1.additionalTopics') | translate
        }}
      </p>
      <div class="company-detail-topics">
        <div class="company-detail-topic" *ngFor="let item of company.additional_topics">
          <app-ui-tooltip
            [icon]="item.icon"
            [content]="item.desc"
            [title]="item.name"
            size="large"
            (mouseenter)="trackTooltip(item.name)"
          ></app-ui-tooltip>
        </div>
      </div>
    </div>
    <div class="company-detail-conflicts" *ngIf="company.criteria_dismatch?.length">
      <div class="company-detail-conflicts-top">
        <app-ui-tooltip
          [icon]="'/assets/images/icons/yellow-warning.svg'"
          [content]="'new_strategy.matches_screen.criteria_dismatch' | translate"
          size="medium"
          (mouseenter)="trackTooltip('criteriaDismatch')"
        ></app-ui-tooltip>
        <span>{{ 'new_strategy.matches_screen.criteria_dismatch' | translate }}</span>
      </div>
      <div class="company-detail-conflicts-down">
        <div class="company-detail-topic" *ngFor="let item of company.criteria_dismatch">
          <app-ui-tooltip
            [icon]="item.icon"
            [content]="item.desc"
            [title]="item.name"
            size="large"
            (mouseenter)="trackTooltip(item.name)"
          ></app-ui-tooltip>
        </div>
      </div>
    </div>
    <div class="company-detail-list" *ngIf="company.good_bullet_points?.length">
      <p class="category-title">{{ 'companyDescription.section2.title' | translate }}</p>
      <ng-container *ngIf="company.good_bullet_points?.length === 1 && company.good_bullet_points[0].length <= limitSize[1]; else shortenGood">
        <div class="company-detail-list-item">
          <span class="icon-i-checkmark-circle"></span>
          <div>
            <span>{{ company.good_bullet_points[0] }}</span>
          </div>
        </div>
      </ng-container>
      <ng-template #shortenGood>
        <ng-container *ngIf="limitGoodDesc; else showAllGood">
          <div class="company-detail-list-item">
            <span class="icon-i-checkmark-circle"></span>
            <div>
              <span class="limit-text">{{ company.good_bullet_points[0] | slice: 0 : limitSize[1] }}</span>
              <strong class="more" (click)="limitCopy('limitGoodDesc')">{{ 'companyDescription.readMore' | translate }}</strong>
            </div>
          </div>
        </ng-container>
        <ng-template #showAllGood>
          <div class="company-detail-list-item" *ngFor="let item of company.good_bullet_points">
            <span class="icon-i-checkmark-circle"></span>
            <span>{{ item }}</span>
          </div>
          <strong (click)="limitCopy('limitGoodDesc')">{{ 'companyDescription.showLess' | translate }}</strong>
        </ng-template>
      </ng-template>
    </div>
    <div class="company-detail-list" *ngIf="company.bad_bullet_points?.length">
      <p class="category-title">{{ 'companyDescription.section3.title' | translate }}</p>
      <ng-container *ngIf="company.bad_bullet_points?.length === 1 && company.bad_bullet_points[0].length <= limitSize[1]; else shortenBad">
        <div class="company-detail-list-item">
          <span class="icon-i-info"></span>
          <div>
            <span>{{ company.bad_bullet_points[0] }}</span>
          </div>
        </div>
      </ng-container>
      <ng-template #shortenBad>
        <ng-container *ngIf="limitBadDesc; else showAllBad">
          <div class="company-detail-list-item">
            <span class="icon-i-info"></span>
            <div>
              <span class="limit-text">{{ company.bad_bullet_points[0] | slice: 0 : limitSize[1] }}</span>
              <strong class="more" (click)="limitCopy('limitBadDesc')">{{ 'companyDescription.readMore' | translate }}</strong>
            </div>
          </div>
        </ng-container>
        <ng-template #showAllBad>
          <div class="company-detail-list-item" *ngFor="let item of company.bad_bullet_points">
            <span class="icon-i-info"></span>
            <span>{{ item }}</span>
          </div>
          <strong (click)="limitCopy('limitBadDesc')">{{ 'companyDescription.showLess' | translate }}</strong>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>
<ng-template #noData>
  <div class="company-detail skeleton-wrapper" [ngClass]="{ active: view === 'portfolio' }">
    <div class="company-wrapper">
      <div class="img skeleton"></div>
    </div>
    <div class="company-topics">
      <div class="img skeleton"></div>
      <div class="img skeleton"></div>
    </div>
    <div>
      <div class="company no-hover">
        <div class="p skeleton"></div>
      </div>
      <div class="company no-hover">
        <div class="title-holder">
          <div class="title skeleton"></div>
          <div class="title skeleton"></div>
        </div>
      </div>
    </div>
    <div class="company no-hover">
      <div class="p skeleton"></div>
    </div>
  </div>
</ng-template>
